import { CHECK_PASSWORD } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

interface PasswordResponse {
    valid: boolean | null;
    pwd: boolean | string;
}

export interface CheckPasswordState extends BaseAsyncReducerState {
    password: PasswordResponse;
}
// Define an initial state value for the app
const initialState: CheckPasswordState = {
    loading: false,
    error: false,
    password: {
        valid: true,
        pwd: false
    }
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function checkPasswordReducer(state = initialState, action: AppAction): CheckPasswordState | Record<string, unknown> {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case CHECK_PASSWORD.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                success: false,
            }
        case CHECK_PASSWORD.SUCCESS:
            return {
                ...state,
                password: { ...payload },
                loading: false,
                error: false,

            }
        case CHECK_PASSWORD.ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                data: payload,
            };
        case CHECK_PASSWORD.RESET:
            return {
                ...state,
                ...initialState
            }
        default:
            return state
    }
}



export default checkPasswordReducer;